export const USER_TOKEN_STORAGE_KEY = 'AuthorisationToken';
export const REDIRECT_URL_STORAGE_KEY = 'RedirectTo';
export const USE_LICIOUS_OAUTH = true;
